import * as React from 'react';
import { connect } from 'react-redux';
import { isTablet } from 'react-device-detect';
import {
    Button,
    ButtonGroup,
    CloseButton,
    Icons,
    LinkButton,
    Panel,
    PanelBody,
    PanelFooter,
    PanelHeader,
    Preloader
} from 'components';
import { IState } from 'services/root-reducer';
import { EOperationStatus, IAppConfig, IOperation } from 'types';
import {
    BaseLayerCode,
    ComparableLayers,
    favouritesContainersCodes,
    layersWithToc,
    pdfContainerCodes
} from 'project-constants';
import {
    getFavorites,
    getHints,
    getLayerIcon,
    getOmjsContainer,
    getOmjsLayerConfig,
    getOperation, getOperationData,
    getTopContainer
} from 'selectors';
import { actions as operationsActions } from 'services/operations/operations-service';
import { actions as mapActions } from 'services/map/map-service';
import { actions as favoritesActions } from 'services/favorites/favorites-service';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { formatApiUrl, ObjectsHelper } from 'utils';
import {
    actions as objectWindowActions,
    IShowObjectWindowOperationData
} from 'services/object-window/object-window-service';

import './style.scss';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IObjectRouteParams, routes } from 'routes';
import clsx from 'clsx';
import i18next from 'i18next';
import { WithTranslation, withTranslation } from 'react-i18next';
import { actions as appActions } from 'services/app/app-service';
import { HelpButtonWithPopover } from 'components/help-button';
import { IContainer } from 'types/omjs/project';
import { ObjectInfo, ObjectInfoComponent } from './object-info';
import { ObjectMedia } from './object-media';
import { ObjectToc } from './object-toc';
import { actions as containersActions } from '../../services/containers/containers-service';

export enum ObjectWindowTab {
    Info, Gallery
}

/* eslint-disable */
export interface IObjectWindowProps extends     RouteComponentProps<IObjectRouteParams>,
                                                WithTranslation
{
/* eslint-enable */
    showObjectOperation: IOperation<IShowObjectWindowOperationData>;
    // layerConfig: omjs.ILayerConfig | false;
    // topContainer: omjs.Container | false;
    // windowIcon: string;
    apiUrlWithVersion: string;
    config: IAppConfig;
    favorites: IState['favorites']['items'];
    isInFavorites: boolean;
    hints: any[];
    zoomOnMount?: boolean;
    containers: IContainer[];
    authToken: string
}
export interface IObjectWindowState {
    activeTab: ObjectWindowTab;
    tocVisible: boolean;
    showPowers: boolean;
}

const mapStateToProps = (state: IState) => {
    let operation: IObjectWindowProps['showObjectOperation'] = getOperation(state, 'SHOW_OBJECT_WINDOW');
    let operation_success = operation?.status === EOperationStatus.SUCCESS;
    let { config } = state.app;
    let favorites = getFavorites(state);
    let in_favorites = operation_success
        ? (favorites[operation.data.layer_code]?.includes(operation.data.object.id) ?? false)
        : false;
    return {
        showObjectOperation: operation,
        apiUrlWithVersion: formatApiUrl(config.apiUrl),
        config: config,
        favorites: getFavorites(state),
        isInFavorites: in_favorites,
        hints: getHints(state),
        containers: getOperationData(state, 'CONTAINERS'),
        authToken: state.app.authToken
    };
};

class ObjectWindowComponent extends React.Component<IObjectWindowProps, IObjectWindowState> {
    private ObjectInfoComponent: ObjectInfoComponent;
    /**
     * Флаг/костыль для зума к объекту при инициализации компонента после загрузки всех данных.
     * false означает что зумится не надо
     * true означает что как только сработает componenDidUpdate будет вызван метод для зума к объекту
     */
    private _zoomOnMountNotResolved = false;

    constructor(props: IObjectWindowProps) {
        super(props);

        this.state = this.getInitialState();

        this.onCloseClick = this.onCloseClick.bind(this);
        this.onPDFClick = this.onPDFClick.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onZoomToObjectClick = this.onZoomToObjectClick.bind(this);
        this.onFavoritesClick = this.onFavoritesClick.bind(this);
        this.onDataUpdateClick = this.onDataUpdateClick.bind(this);
        this.loadObjectData = this.loadObjectData.bind(this);
    }

    getInitialState(showPowers?: boolean) {
        return {
            activeTab: ObjectWindowTab.Info,
            tocVisible: false,
            showPowers: showPowers || false
        };
    }

    componentDidMount() {
        let { zoomOnMount = false } = this.props;
        let { layerCode, objectId } = this.props.match.params;

        if (i18next.language !== 'ru' && [
            'oks_po_dannym_kpt',
            'zu_po_dannym_kpt',
            'investment_projects',
            'productive_agricultural_land'
        ].includes(layerCode)) {
            routes.goBack(routes.map, { container: 'root' }, routes.currRouteState);
            containersActions.setContainerSelected({ id_or_code: layerCode, selected: false });
            return;
        }
        this.setTitle();

        if (isTablet) {
            appActions.hideObjectFiltersWindow();
        }
        if (!ComparableLayers.has(layerCode)) {
            mapActions.getConnections([ 0, 0 ]);
        } else {
            mapActions.getConnectionsByObject({
                layerCode: layerCode,
                objectId: parseInt(objectId)
            });
        }

        this.loadObjectData();

        if (zoomOnMount) {
            this._zoomOnMountNotResolved = true;
        }
    }

    componentDidUpdate(prevProps: Readonly<IObjectWindowProps>) {
        let { layerCode, objectId } = this.props.match.params;

        this.setTitle();

        if (isTablet) {
            appActions.hideObjectFiltersWindow();
        }
        if (!ComparableLayers.has(layerCode)) {
            mapActions.getConnections([ 0, 0 ]);
        }

        let { layerCode: prevLayerCode, objectId: prevObjectId } = prevProps.match.params;
        if (layerCode !== prevLayerCode || objectId !== prevObjectId) {
            /* eslint-disable-next-line */
            this.setState(this.getInitialState());

            if (ComparableLayers.has(layerCode)) {
                mapActions.getConnectionsByObject({
                    layerCode: layerCode,
                    objectId: parseInt(objectId)
                });
            }

            objectWindowActions.showObjectWindow({
                object_id: parseInt(objectId),
                layer_code: layerCode
            });
        }

        if (this.props.showObjectOperation?.status !== prevProps.showObjectOperation?.status
            && this.props.showObjectOperation?.status === EOperationStatus.SUCCESS) {
            const { geom, fullGeom } = this.props.showObjectOperation.data.object;
            const g = (fullGeom || geom);
            if (g) {
                mapActions.setObjectHighlight(g);
            }
            if (this._zoomOnMountNotResolved) {
                this._zoomOnMountNotResolved = false;
                this.onZoomToObjectClick();
            }
        }
    }

    componentWillUnmount() {
        mapActions.setObjectHighlight(null);
    }

    setTitle() {
        let { showObjectOperation } = this.props;
        if (showObjectOperation && showObjectOperation.status === EOperationStatus.SUCCESS) {
            let layerConfig = getOmjsLayerConfig(false, showObjectOperation.data.layer_code) as omjs.ILayerConfig;
            let { object } = showObjectOperation.data;
            let title = ObjectsHelper.getObjectName(object, layerConfig);
            title = String(title || '').replace(/&quot;/ig, '"');
            document.title = `${title}. ${i18next.t('Ленинградская область')}`;
        }
    }

    onPDFClick() {
        let {
            apiUrlWithVersion,
            config,
            i18n,
            showObjectOperation,
            authToken
        } = this.props;

        let topContainer = getTopContainer(false, showObjectOperation.data.layer_code) as omjs.Container;
        let { object, layer_code } = showObjectOperation.data;

        // код оригинального слоя, по которому созданы виртуальные слои категорий
        let baseLayerCode = BaseLayerCode[topContainer.get('code')] || layer_code;

        let path = `${apiUrlWithVersion + config.mapCode}/layers/${baseLayerCode}/objects/${object.id}/`;
        let query = `f=pdf&custom=1&lng=${i18n.language}&dl=1`;
        if (authToken) {
            query += `&token=${authToken}`;
        }
        window.open(`${path}?${query}`);
    }

    onLinkClick() {
        let { showObjectOperation, i18n } = this.props;
        let { layer_code, object } = showObjectOperation.data;

        let object_link = ObjectsHelper.getObjectLink({
            layer_code,
            object_id: object.id
        });

        overlayWindowsActions.showObjectLinkOverlay(object_link);
    }

    onCloseClick(event: React.MouseEvent) {
        let { showObjectOperation } = this.props;
        let { layer_code } = showObjectOperation.data;
        operationsActions.clearOperation('SHOW_OBJECT_WINDOW');
        mapActions.getConnections([ 0, 0 ]);
        const { navigation } = routes;
        let removeNavItem = false;

        if (navigation.length) {
            removeNavItem = navigation[navigation.length - 1].params.objectId !== undefined;
            if (navigation[navigation.length - 1].route.path.indexOf('/list/') === 0) {
                let listLayerCode = navigation[navigation.length - 1].params.layerCode;
                let topContainerCode = getTopContainer(false, layer_code).get('code');
                removeNavItem = (
                    removeNavItem || (layer_code !== listLayerCode && topContainerCode !== listLayerCode)
                );
            }
        }

        while (removeNavItem) {
            routes.navigation.pop();
            if (navigation.length) {
                removeNavItem = navigation[navigation.length - 1].params.objectId !== undefined;
                if (navigation[navigation.length - 1].route.path.indexOf('/list/') === 0) {
                    let listLayerCode = navigation[navigation.length - 1].params.layerCode;
                    let topContainerCode = getTopContainer(false, layer_code).get('code');
                    removeNavItem = (
                        removeNavItem || (layer_code !== listLayerCode && topContainerCode !== listLayerCode)
                    );
                }
            } else {
                removeNavItem = false;
            }
        }

        // while (routes.navigation.length && routes.navigation[routes.navigation.length - 1].params.objectId) {
        //     routes.navigation.pop();
        // }
        routes.goBack(routes.map, { container: 'root' }, routes.currRouteState);
    }

    onZoomToObjectClick() {
        let { object, layer_code } = this.props.showObjectOperation.data;
        appActions.hideObjectFiltersWindow();
        const cont = getOmjsContainer(false, layer_code, true);
        if (cont.get('render_type') === 0) {
            const objGeom = object['geom'];
            if (objGeom) {
                const geom = new omjs.ol.geom[objGeom.type](objGeom.coordinates);
                mapActions.fitToExtent(geom.getExtent());
            }
        } else {
            mapActions.fitToTarget({
                layer: layer_code,
                objectId: object.id
            });
        }
    }

    onFavoritesClick() {
        let { isInFavorites } = this.props;
        let { object, layer_code } = this.props.showObjectOperation.data;
        if (isInFavorites) {
            favoritesActions.removeItem({ layer_code, object_id: object.id });
        } else {
            favoritesActions.addItem({ layer_code, object_id: object.id });
        }
    }

    onDataUpdateClick() {
        let { showObjectOperation } = this.props;
        let { object, layer_code } = this.props.showObjectOperation.data;

        let layerConfig = getOmjsLayerConfig(false, showObjectOperation.data.layer_code) as omjs.ILayerConfig;

        overlayWindowsActions.showUpdateDataOverlay({
            layer_code,
            object_id: object.id,
            object_name: ObjectsHelper.getObjectName(object, layerConfig),
            object_url: ObjectsHelper.getObjectLink({
                layer_code,
                object_id: object.id
            })
        });
    }

    onTocClick() {
        appActions.hideObjectFiltersWindow();
        this.setState(state => ({
            tocVisible: !state.tocVisible,
            activeTab: ObjectWindowTab.Info
        }));
    }

    loadObjectData() {
        let { layerCode, objectId } = this.props.match.params;

        objectWindowActions.showObjectWindow({
            object_id: parseInt(objectId),
            layer_code: layerCode
        });
    }

    renderPreloader() {
        return (
            <Panel className={clsx('object-window-wrapper', 'preloader-wrapper')}>
                <Preloader />
            </Panel>
        );
    }

    renderError() {
        let { t } = this.props;
        return (
            <Panel className={clsx('object-window-wrapper', 'error')}>
                <PanelHeader className="object-window-header">
                    <div className="window-close">
                        <CloseButton
                            onClick={this.onCloseClick}
                        />
                    </div>
                </PanelHeader>
                <PanelBody className='object-window-body'>
                    <div className='error-message'>
                        {t('Ошибка загрузки')}
                    </div>
                    <div>
                        <LinkButton
                            className='retry-button'
                            onClick={this.loadObjectData}
                            label={t('Повторить')}
                        />
                    </div>
                </PanelBody>
            </Panel>
        );
    }

    renderHelpButton(containerCode: string) {
        if (containerCode.indexOf('plots') === 0 || containerCode.indexOf('parks') === 0) {
            const hint = this.props.hints.find(obj => obj.get('code') === 'info_window');
            if (hint) {
                const { title, text } = hint['_attributes'];
                return (
                    <HelpButtonWithPopover
                        className="for-objects-window"
                        popoverProps={{
                            placement: 'bottom',
                            className: 'help-button-popover bottom-placement'
                        }}
                        offset={[ 0, 24 ]}
                    >
                        <div className="header">
                            {title}
                        </div>
                        <div className="body">
                            {text}
                        </div>
                    </HelpButtonWithPopover>
                );
            }
        }

        return null;
    }

    render() {
        let {
            showObjectOperation,
            isInFavorites,
            t,
            containers
        } = this.props;

        if (
            !showObjectOperation
            || showObjectOperation.status === EOperationStatus.PENDING
            || showObjectOperation.status === EOperationStatus.UNKNOWN
        ) {
            return this.renderPreloader();
        } else if (showObjectOperation.status === EOperationStatus.FAIL) {
            return this.renderError();
        }
        const layerCode = showObjectOperation.data.layer_code;
        let layerConfig = getOmjsLayerConfig(false, layerCode) as omjs.ILayerConfig;
        let { object, structure, filtered_structure } = showObjectOperation.data;
        let image_column_code = ObjectsHelper.getImagesColumnCode(object, layerConfig);
        let file_columns = ObjectsHelper.getFilesColumnCodes(object, structure, layerConfig);
        let has_media = !!image_column_code || file_columns.length > 0;
        const withConnections = [ 'sites_1', 'sites_2', 'sites_3', 'sites_4' ]
            .includes(showObjectOperation?.data?.layer_code);
        const withBanner = [ 'sites_1', 'sites_2', 'sites_3', 'sites_4', 'parks_3', 'parks_2', 'parks_1' ]
            .includes(showObjectOperation?.data?.layer_code);

        return (
            <Panel
                className={clsx('object-window-wrapper', {
                    'toc-visible': this.state.tocVisible
                })}
            >
                <div className="left-block">
                    <PanelHeader className="object-window-header">
                        <div className="window-icon">
                            <img
                                alt=""
                                src={getLayerIcon(false, {
                                    layer_code: showObjectOperation.data.layer_code,
                                    object_id: showObjectOperation.data.object.id
                                })}
                            />
                        </div>
                        <div
                            className="window-title"
                            dangerouslySetInnerHTML={{
                                __html: ObjectsHelper.getObjectName(object, layerConfig)
                            }}
                        />
                        {this.renderHelpButton(showObjectOperation.data.layer_code)}
                        {
                            !this.state.tocVisible && (
                                <div className="window-close">
                                    <CloseButton
                                        onClick={this.onCloseClick}
                                    />
                                </div>
                            )
                        }
                    </PanelHeader>
                    <PanelBody className='object-window-body'>
                        {/*
                        <div
                            className={clsx('toc-button-wrapper')}
                            style={{
                                visibility: this.state.tocVisible ? 'hidden' : 'visible'
                            }}
                        >
                            {layersWithToc.includes(showObjectOperation.data.layer_code) && (
                                <TOCToggleButton
                                    onClick={() => {
                                        appActions.hideObjectFiltersWindow();
                                        this.setState(state => ({
                                            tocVisible: !state.tocVisible,
                                            activeTab: ObjectWindowTab.Info
                                        }));
                                    }}
                                />
                            )}
                        </div>
                        */}
                        <div className="object-data">
                            <div className="sidebar-tabs">
                                <LinkButton
                                    icon={<Icons.IconInfo />}
                                    active={this.state.activeTab === ObjectWindowTab.Info}
                                    onClick={() => {
                                        this.setState({
                                            activeTab: ObjectWindowTab.Info,
                                            tocVisible: false
                                        });
                                    }}
                                />
                                {layersWithToc.includes(showObjectOperation.data.layer_code) && (
                                    <LinkButton
                                        icon={<Icons.IconToc />}
                                        active={this.state.tocVisible}
                                        onClick={() => this.onTocClick()}
                                    />
                                )}
                                { has_media && (
                                    <LinkButton
                                        icon={![ 'investment_projects', 'investment_projects_apk' ].includes(layerCode)
                                            ? <Icons.IconCamera />
                                            : <Icons.IconDoc />}

                                        active={this.state.activeTab === ObjectWindowTab.Gallery}
                                        onClick={() => {
                                            this.setState({
                                                activeTab: ObjectWindowTab.Gallery,
                                                tocVisible: false
                                            });
                                        }}
                                    />
                                )}
                            </div>
                            {this.state.activeTab === ObjectWindowTab.Info && (
                                <ObjectInfo
                                    object={object}
                                    structure={filtered_structure}
                                    layerConfig={layerConfig}
                                    t={t}
                                    withBanner={withBanner}
                                    withConnections={withConnections}
                                    ref={(c) => {
                                        this.ObjectInfoComponent = c;
                                    }}
                                    containers={containers}
                                />
                            )}
                            {this.state.activeTab === ObjectWindowTab.Gallery && (
                                <ObjectMedia
                                    object={object}
                                    filesColumns={file_columns}
                                    imagesColumn={image_column_code}
                                    layerConfig={layerConfig}
                                    layerCode={layerCode}
                                />
                            )}
                        </div>
                    </PanelBody>
                    <PanelFooter className='object-window-footer'>
                        <ButtonGroup>
                            {object['geom'] && (
                                <Button
                                    variant='blue'
                                    onClick={this.onZoomToObjectClick}
                                    icon={<Icons.IconMagnifyGlassPlus />}
                                    text={t('Приблизить')}
                                />
                            )}
                            {
                                !__IS_CORDOVA__ && (
                                    <Button
                                        title={t('Ссылка на объект')}
                                        variant='blue'
                                        onClick={this.onLinkClick}
                                        icon={<Icons.IconLink />}
                                    />
                                )
                            }
                            {pdfContainerCodes.includes(showObjectOperation.data.layer_code) && (
                                <Button
                                    title={t('Скачать PDF')}
                                    variant="blue"
                                    onClick={this.onPDFClick}
                                    icon={<Icons.IconPdf />}
                                />
                            )}
                            {favouritesContainersCodes.includes(showObjectOperation.data.layer_code) && (
                                <>
                                    <Button
                                        title={i18next.t('Добавить в избранное')}
                                        variant="blue"
                                        onClick={this.onFavoritesClick}
                                        className={clsx({
                                            'in-favorites-icon-color': isInFavorites
                                        })}
                                        icon={<Icons.IconStar />}
                                    />
                                    <Button
                                        title={t('Заявка на обновление данных')}
                                        variant="blue"
                                        className='data-update-button'
                                        onClick={this.onDataUpdateClick}
                                        icon={<Icons.IconNote />}
                                    />
                                </>
                            )}
                        </ButtonGroup>
                    </PanelFooter>
                </div>

                {
                    this.state.tocVisible && (
                        <div className='right-block'>
                            <div className="header">
                                <div className="header-text">
                                    {t('Оглавление')}
                                </div>
                                <div className="window-close">
                                    <CloseButton
                                        onClick={() => {
                                            this.setState(state => ({
                                                tocVisible: false,
                                                activeTab: ObjectWindowTab.Info
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="body">
                                <ObjectToc
                                    object={object}
                                    structure={filtered_structure}
                                    layerConfig={layerConfig}
                                    onHeaderClick={(column) => {
                                        this.ObjectInfoComponent.scrollToColumn(column);
                                    }}
                                />
                            </div>
                        </div>
                    )
                }

                {/* {this.state.link_window_link && (
                    <LinkWindow
                        link={this.state.link_window_link}
                        onClose={() => {
                            this.setState({
                                link_window_link: null
                            });
                        }}
                    />
                )} */}
            </Panel>
        );
    }
}

export const ObjectWindow = withRouter(
    // @ts-ignore
    withTranslation()(
        connect(mapStateToProps)(ObjectWindowComponent)
    )
);
